; (function ($, window, document, undefined) {

    var name = 'customLocaleInput';

    function Plugin(element, options) {
        this.element = element;
        this._name = name;
        this._defaults = $.fn.customLocaleInput.defaults;
        this.options = $.extend({}, this._defaults, options);
        this.initialize();
    }

    $.extend(Plugin.prototype, {
        initialize: function () {
            this.buildCache();
            this.bindEvents();

            $.ajax({
                type: 'GET',
                context: this,
                url: '/js/data/locale.json',
                beforeSend: function () {
                }, success: function (data) {
                    this.options.states = data;
                    this.populateStates();
                    this.populateCities(this.$element.val());
                }
            });
        },

        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        buildCache: function () {
            this.$element = $(this.element);
            this.$cityInput = this.options.cityInput;
        },

        bindEvents: function () {
            var plugin = this;

            plugin.$element.on('change', function () {
                plugin.populateCities($(this).val());
            });
        },

        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        populateStates: function () {
            this.$element.empty();
            this.$element.append(`<option value selected disabled>Select State</option>`);
            Object.keys(this.options.states).forEach(state => {
                this.$element.append(`<option>${state}</option>`);
            });

            return this;
        },

        populateCities: function (state) {
            this.$cityInput.empty();
            this.$cityInput.append(`<option value selected disabled>Select City</option>`);
            if (state) {
                this.options.states[state].forEach(city => {
                    this.$cityInput.append(`<option>${city}</option>`);
                });
            }

            return this;
        },

        resetCityInput: function (input) {
            this.$cityInput = input;
            this.populateCities(this.$element.val());

            return this;
        }
    });

    $.fn.customLocaleInput = function (options) {
        this.each(function () {
            if (!$.data(this, name)) {
                $.data(this, name, new Plugin(this, options));
            }
        });

        return this;
    };

    $.fn.customLocaleInput.defaults = {
        states: {},
        cityInput: null,
    };

})(jQuery, window, document);
